import { render, staticRenderFns } from "./userbind.vue?vue&type=template&id=36c307ab&scoped=true&"
import script from "./userbind.vue?vue&type=script&lang=js&"
export * from "./userbind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c307ab",
  null
  
)

export default component.exports